// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2O0Cg","rootSuccess":"CompleteLink_rootSuccess__33xQO","rootFailure":"CompleteLink_rootFailure__6-OvT","isDisabled":"CompleteLink_isDisabled__bcR21"};